import { createRootComponent } from '../utils/create-root-component'

import { LandingPageApp } from '@/apps/landing-page'
import { UiBrandAppProvider } from '@/providers/UiBrandAppProvider'

export default createRootComponent('landing-page', LandingPageApp, {
  Wrapper: UiBrandAppProvider,
})
